import "./Footer.css";
import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function Footer() {

  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      alert("Please enter your email");
      return;
    }

    try {
      const response = await axios.post(
        "http://localhost:5000/api/subscribe",
        { email }
      );

      alert(response.data.message);

      setEmail("");
    } catch (error) {
      console.log(error);
      alert("Subscription failed");
    }
  };

  return (
    <footer className="footer">

      <div className="footer-top">

        {/* LEFT SIDE */}
        <div className="footer-left">
          <h3>Stay updated always</h3>
          <p className="footer-note">
            Get news about our latest initiatives and impact
          </p>
        </div>

        {/* RIGHT SIDE Subscribe */}
        {/* <div className="footer-right">
          <div className="subscribe-box">
            <input type="email" 
            placeholder="info@dharafoundation.com" 
            value={email}
              onChange={(e) => setEmail(e.target.value)}
              />
            <button onClick={handleSubscribe}>
              Subscribe
            </button>
          </div>

          <p className="footer-policy">
            By subscribing you agree to our Privacy Policy
          </p>
        </div> */}

      </div>

      <div className="footer-links">

        <div>
          <h4>About us</h4>
          <p>Our mission</p>
          <p>
             <Link to="/aboutus"
             state={{ scrollTo: "vision" }}
             className="footer-link">
             Our vision</Link>
            </p>
            
          <p>Our story</p>
          <p>Team members</p>
        </div>

        <div>
          <h4>Get involved</h4>
          <p>Volunteer </p>
          <p>Donate now</p>
          <p>Community development</p>
          <p>Youth empowerment</p>
        </div>

        <div>
          <h4>Our work</h4>
          <p>Education programs</p>
          <p>Environmental action</p>
          <p>Health initiatives</p>
        </div>

        <div>
          <h4>Resources</h4>
          <p>Impact reports</p>
          <p>Annual newsletter</p>
          <p>Photo gallery</p>
          <p>Success stories</p>
        </div>

        <div>
          <h4>Connect with us</h4>
          <p>Email us today</p>
          <p>Call our office</p>
          <p>Visit in person</p>
          <p>Follow us</p>
        </div>

        <div>
          <h4>Legal</h4>
          <p>Terms of service</p>
          <p>Privacy policy</p>
          <p>Disclaimer notice</p>
          <p>Cookie settings</p>
          <p>Accessibility info</p>
          <p>Sitemap</p>
        </div>

      </div>

    </footer>
  );
}

export default Footer;